export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "srPageLoading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page loading"])}
      },
      "fr": {
        "srPageLoading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement de page"])}
      }
    }
  })
}
